export const JOURNAL = "Journal"
export const JOURNAL_ENTRY = "Journal Entry"
export const SAVE = "Save"


export const  JOURNAL_ENTRY_PAGES = {
    TABLE: "table",
    EDIT: "edit"
}

export const JOURNAL_ENTRY_FIELDS = [
    {id: 'journalEntryDate', label: 'Date', align: "left"},
    {id: 'journalEntryDescription', label: 'Description', align: "left"},
    {id: 'amount', label: 'Amount', align: "left"},
    { id: 'details',label: ''},
]


// tooltip names
export const BACK = "Back to Menu"
